export default {"src":"/_next/static/media/mobile_ray.7b28d7da.gif","height":300,"width":480,"blurWidth":0,"blurHeight":0};